/** Apply one card checkbox toggle without exceeding the batch selection cap. */
export function toggleRegulationSelection(
  current: readonly string[],
  regulationId: string,
  checked: boolean,
  maxCount: number,
): { next: string[]; limitReached: boolean } {
  if (!checked) {
    return {
      next: current.filter((id) => id !== regulationId),
      limitReached: false,
    };
  }
  if (current.includes(regulationId)) {
    return { next: [...current], limitReached: false };
  }
  if (current.length >= maxCount) {
    return { next: [...current], limitReached: true };
  }
  return { next: [...current, regulationId], limitReached: false };
}
